// STATE 
export const tabData = {
    id: "",
    tabName: "",
    reRenderTablist: false
};

// REDUCER
export const TabDataReducer = (state, action) => {
    switch (action.type) {
        case 'updateTabData':
            return { id: action.payload.id, tabName: action.payload.tabName }
        case 'reRenderTabList':
            return { ...state, reRenderTablist: true }
        default:
            return tabData
    }
}